import { Sparkles } from 'lucide-react';
import { BlocoCampos, CampoArea, Interruptor } from '../componentes/campos';
import { ListaEditavel } from '../componentes/lista-editavel';
import { ABREVIATURAS_PADRAO, GLOSSARIO_PADRAO } from '../manual-catalogos';
import { novoGlossario } from '../manual-defaults';
import { TEXTOS } from '../manual-textos';
import type { ItemGlossario } from '../manual-types';
import type { PropsSecao } from './tipos';

export function SecaoEncerramento({ editor }: PropsSecao) {
  const { dados, definirCampo, definirOpcao, adicionarItem, adicionarItens, atualizarItem, removerItem, moverItem } = editor;

  return (
    <>
      <BlocoCampos titulo="Desativação, desmontagem e descarte" descricao="Capítulo 7 — já preenchido com o texto padrão do template; ajuste se a máquina exigir procedimento próprio.">
        <CampoArea rotulo="Desativação (7.1)" linhas={3} valor={dados.desativacao} placeholder={TEXTOS.desativacao} aoMudar={(valor) => definirCampo('desativacao', valor)} />
        <CampoArea rotulo="Desmontagem (7.2)" linhas={3} valor={dados.desmontagem} placeholder={TEXTOS.desmontagem} aoMudar={(valor) => definirCampo('desmontagem', valor)} />
        <CampoArea rotulo="Descarte (7.3)" linhas={3} valor={dados.descarte} placeholder={TEXTOS.descarte} aoMudar={(valor) => definirCampo('descarte', valor)} />
      </BlocoCampos>

      <BlocoCampos
        titulo="Glossário"
        descricao="Capítulo 8 — termos técnicos usados no documento."
        acoes={
          <button
            type="button"
            className="manual-ghost-button"
            onClick={() => adicionarItens('glossario', GLOSSARIO_PADRAO.map((item) => novoGlossario(item)))}
          >
            <Sparkles />Carregar glossário padrão
          </button>
        }
      >
        <Interruptor
          rotulo="Incluir glossário no documento"
          ativo={dados.opcoes.incluirGlossario}
          aoMudar={(ativo) => definirOpcao('incluirGlossario', ativo)}
        />
        {dados.opcoes.incluirGlossario && (
          <ListaEditavel<ItemGlossario>
            itens={dados.glossario}
            colunas={[
              { chave: 'termo', rotulo: 'Termo', placeholder: 'Ex.: Zona de perigo' },
              { chave: 'definicao', rotulo: 'Definição', placeholder: 'Descrição objetiva do termo', largura: '2.6fr', tipo: 'area' },
            ]}
            rotuloAdicionar="Adicionar termo"
            vazio="Nenhum termo cadastrado."
            aoAdicionar={() => adicionarItem('glossario', novoGlossario())}
            aoAtualizar={(id, patch) => atualizarItem('glossario', id, patch)}
            aoRemover={(id) => removerItem('glossario', id)}
            aoMover={(id, direcao) => moverItem('glossario', id, direcao)}
          />
        )}
      </BlocoCampos>

      <BlocoCampos
        titulo="Abreviaturas"
        descricao="Siglas utilizadas ao longo do manual."
        acoes={
          <button
            type="button"
            className="manual-ghost-button"
            onClick={() => adicionarItens('abreviaturas', ABREVIATURAS_PADRAO.map((item) => novoGlossario(item)))}
          >
            <Sparkles />Carregar abreviaturas padrão
          </button>
        }
      >
        <Interruptor
          rotulo="Incluir abreviaturas no documento"
          ativo={dados.opcoes.incluirAbreviaturas}
          aoMudar={(ativo) => definirOpcao('incluirAbreviaturas', ativo)}
        />
        {dados.opcoes.incluirAbreviaturas && (
          <ListaEditavel<ItemGlossario>
            itens={dados.abreviaturas}
            colunas={[
              { chave: 'termo', rotulo: 'Sigla', placeholder: 'Ex.: EPI', largura: '0.6fr' },
              { chave: 'definicao', rotulo: 'Significado', placeholder: 'Ex.: Equipamento de Proteção Individual', largura: '3fr' },
            ]}
            rotuloAdicionar="Adicionar abreviatura"
            vazio="Nenhuma abreviatura cadastrada."
            aoAdicionar={() => adicionarItem('abreviaturas', novoGlossario())}
            aoAtualizar={(id, patch) => atualizarItem('abreviaturas', id, patch)}
            aoRemover={(id) => removerItem('abreviaturas', id)}
            aoMover={(id, direcao) => moverItem('abreviaturas', id, direcao)}
          />
        )}
      </BlocoCampos>
    </>
  );
}
